import script from "./CustomSubstanceModal.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomSubstanceModal.vue?vue&type=script&setup=true&lang=js"

import "./CustomSubstanceModal.vue?vue&type=style&index=0&id=2fa9bdc6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2fa9bdc6"]])

export default __exports__